import { PostActionFunction } from "csi/def/Action";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ActionData from "csi/heading/ActionData";
import Enum from "csi/heading/Enum";
import { ViewWidget } from "csi/view/Widget";
import TextWithMaterialIcon from "csi/widget/TextWithMaterialIcon";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import { VIEWER, getIconParameters } from "./ProofService";

interface ViewWidgetWithDojoViewParams extends ViewWidget {
	beginProofTaskAction: PostActionFunction;
}

const ProofManagementDecisionStatusRenderer = declare(Enum, {

	/** cnl for proof member role */
	proofMemberRole: null,

	/**
	 * @override
	 * Skip access, we have edit permissions here.
	 */
	_getRenderAction(ctx: Context, h: Heading): ActionData {
		const { queryResult, view } = ctx;

		// update the action for the expanded row, not the group row
		if (queryResult?.level.id !== "1") {
			return this.inherited<ActionData>(arguments);
		}

		const taskNode = ctx.getNode();
		const stageNode = ctx.getNodeParent();
		const documentRevision = ctx.cache.get(view.getViewNode().__Parent__);

		if (documentRevision.ProofIsLocked ||
			stageNode.StageIsLocked ||
			taskNode.TaskDefinition === VIEWER) {
			return this.inherited<ActionData>(arguments);
		}

		const a = this.getAction(ctx, h);
		const viewWidgetWithDojoViewParams = view as ViewWidgetWithDojoViewParams;
		a.m_postAction = viewWidgetWithDojoViewParams.beginProofTaskAction;
		return Object.assign(new ActionData(), {
			action: a,
			bTooltip: false,
			heading: h,
			ren: this,
		});
	},

	/**
	 * @override
	 * Add icon before the text
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: Element, _params) {
		const enumValue = this._getValue(ctx, h);
		const value = xml.enumGetText(enumValue);

		// Do not render if value is not yet defined
		if (!value) {
			return true;
		}

		const text = this.toValue(ctx, h);
		new TextWithMaterialIcon(getIconParameters(value, false, true, text))
			.placeAt(refNode);
		return true;
	},
});

export = ProofManagementDecisionStatusRenderer;